import { render, staticRenderFns } from "./MessageCell.vue?vue&type=template&id=a4409922&scoped=true"
import script from "./MessageCell.vue?vue&type=script&lang=js"
export * from "./MessageCell.vue?vue&type=script&lang=js"
import style0 from "./MessageCell.vue?vue&type=style&index=0&id=a4409922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4409922",
  null
  
)

export default component.exports